import { employerBrandQuery } from '@src/api/queries/employerBrand.ts';
import type { CollectionType, QueryItem } from '@directus/sdk';
import type { Country } from '../services/CountryService';
import type {
  CustomDirectusTypes,
  Organization,
} from '@funnellab/shared/src/types/directus.ts';

export const organizationTableQuery = {
  fields: [
    'id',
    'externalId',
    'name',
    'ownedEmployerBrands',
    'jobs',
    'street',
    'zip',
    'city',
    { country: ['label'] },
  ],
} as const satisfies QueryItem<
  CustomDirectusTypes,
  CollectionType<CustomDirectusTypes, 'organization'>
>;

export type OrganizationDto = Required<
  Pick<
    Organization,
    | 'id'
    | 'name'
    | 'street'
    | 'zip'
    | 'city'
    | 'vatNo'
    | 'billingEmail'
    | 'paymentByInvoice'
  >
> & {
  country: Country | null;
};

export const organizationQuery = {
  fields: [
    'id',
    'name',
    'status',
    'date_created',
    'street',
    'city',
    { country: ['id', 'label', 'subdivision_code', 'country_code'] },
    'zip',
    'vatNo',
    'billingEmail',
    'homepage',
    'branch',
    'numberOfEmployees',
    'credit',
    'paymentByInvoice',
    { ownedEmployerBrands: employerBrandQuery.fields },
  ],
  sort: '-date_created',
} as const satisfies QueryItem<
  CustomDirectusTypes,
  CollectionType<CustomDirectusTypes, 'organization'>
>;
